// extracted by mini-css-extract-plugin
export default {"header":"CannedDeliveryInstructions-module__header___39eVc colors-module__primary___23OPL"};